
import { Component, Vue, Watch } from "vue-property-decorator";
import { SMCases } from "@/store";
import { TCase_Main_Applicant } from "@/models/cases";
import { API_ROUTES } from "@/utils/API";
import { SERVICE_STATUS } from "@/constants/services";

@Component({
  components: {
    Hello: () => import("./Highlight/Hello.vue"),
    InProgress: () => import("./Highlight/InProgress.vue"),
    ReportGenerated: () => import("./Highlight/ReportGenerated.vue"),
    Risk: () => import("./Highlight/Risk.vue"),
    Complete: () => import("./Highlight/Complete.vue"),
  },
})
export default class AssessmentHighlight extends Vue {
  statuses = SERVICE_STATUS;

  get caseId(): number {
    return Number(this.$route.params.id ?? 0);
  }

  childServiceId = 0;

  init = false;

  get status() {
    return SMCases.caseStatus || this.statuses.report_generation;
  }

  get isRisk() {
    const { report_generated, complete } = this.statuses;

    return [report_generated, complete].includes(this.status);
  }

  @Watch("status", { immediate: true })
  async isStatusChanged() {
    if (!this.isRisk) return;

    await this.getCase();
  }

  risk = "";

  caseHasTask = false;

  mainApplicant: TCase_Main_Applicant = {
    first_name: "",
    last_name: "",
    job_title: "",
  };

  get jobTitle() {
    return this.mainApplicant.job_title;
  }

  get name() {
    const { first_name, last_name } = this.mainApplicant;

    return first_name && last_name ? `${first_name} ${last_name}` : "";
  }

  async getCase() {
    try {
      const { data } = await this.axios.get(API_ROUTES.CASE_ID(this.caseId));

      if (!data) return;

      SMCases.setCaseStatus(data.status);

      SMCases.setCase(data);

      this.childServiceId = data.child_case_id;

      this.risk = data.final_decision;

      this.caseHasTask = data.has_task;
      SMCases.setHasTasks(data.has_task);

      this.mainApplicant = data.main_applicant;
      SMCases.setMainApplicant(data.main_applicant);
    } finally {
      this.init = true;
    }
  }

  mounted() {
    if (!this.init) this.getCase();
  }

  activated() {
    // NOTE: This approach helps us to refresh "tasks";
    if (!this.init) this.getCase();
  }
}
